import { APP_DOMAIN, APP_ENV, CONSTANTS } from '../../../../../app-constants';
import { CookieStrategy } from './cookie.strategy';
import { CookieUtils } from './cookie.utils';

class CookieConsentStrategy extends CookieStrategy {
  constructor(domain) {
    super();

    this.key = 'consentMode';
    this.domain = domain;
    this.expiry = 365 * 100; // 100 years in days
  }

  /**
   * @description
   * Set the cookie consent, which is stored as
   * Google Tag Manager preferences.
   *
   * @param {ConsentPreferences} consent
   */
  set(consent) {
    CookieUtils.setEncodedCookie(this.key, consent, this.expiry, this.domain);
  }

  /**
   * @description
   * Get the user consent preferences directly from the cookie, which
   * is stored as Google Tag Manager preferences.
   *
   * @returns {ConsentPreferences | null}
   */
  get() {
    return CookieUtils.getEncodedCookie(this.key);
  }

  /**
   * @description
   * Erase the cookie consent preferences.
   */
  erase() {
    CookieUtils.eraseCookie(this.key, this.domain);
  }
}

// Consistent implementation of cookie consent across all applications, which
// provide a consistent environment variable for the application domain
const isDevelopment = APP_ENV === CONSTANTS.Environment.Development;
// Set to be a domain-wide cookie outside of development
const cookieDomain = !isDevelopment ? `.${APP_DOMAIN}` : null;
export const cookieConsent = new CookieConsentStrategy(cookieDomain);

class LegacyCookieConsentStrategy extends CookieStrategy {
  constructor(legacyKey) {
    super();

    this.key = legacyKey;
    this.domain = null;
    this.expiry = null;
  }

  get() {
    return CookieUtils.getCookie(this.key);
  }

  erase() {
    CookieUtils.eraseCookie(this.key);
  }
}
export const legacyCookieConsent = new LegacyCookieConsentStrategy('consent');
